module.exports = __webpack_public_path__ + "hyperion-v2-static/img/hiscox_logo_white_bg.7538953e.png";